<template lang="pug">
  span(:class="iconClass" @click.stop="openUrl")
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator'
import { Component } from 'vue-property-decorator'
import { Icons } from '@/icons/icons'

@Component({
  name: 'externalUrlTemplate'
})
export default class DocumentsAttachmentTemplateComponent extends Vue {
  data: any

  get getValue() {
    const { field } = this.data.column
    return this.data[field]
  }
  
  get iconClass() {
    if (this.getValue) {
      return Icons.LINK
    }
    return ''
  }

  openUrl() {
    window.open(this.getValue, '_blank')
  }
}
</script>

<style lang="scss" scoped>
.e-templatecell {
  span {
    &:before {
      font-family: $lf-icons-font !important;
      font-size: $icon-size;
      color: $corporate-color;
    }
  }
}
</style>
